import { gql } from '@apollo/client';

export const lessonEnglishContentAreaFragment = gql`
  fragment LessonEnglishContentAreaFragment on Lesson {
    data {
      englishContentArea
    }
  }
`;

export const UPDATE_LESSON_ENGLISH_CONTENT_AREAS = gql`
  mutation UpdateLessonEnglishContentAreas(
    $input: UpdateLessonEnglishContentAreaInput!
  ) {
    updateLessonEnglishContentArea(input: $input) {
      id
      ...LessonEnglishContentAreaFragment
    }
  }
  ${lessonEnglishContentAreaFragment}
`;
